import { getBenchRegistryClient } from "@/lib/clients";
import { queryClient } from "@/lib/query-client";
import { useQuery } from "@tanstack/react-query";
import { RegistryState } from "@myth-finance/bench-sdk";

const queryKeyPrefix = "bench-r";

export const useBenchRegistry = () => {
  return useQuery({
    queryKey: [queryKeyPrefix],
    staleTime: 5 * 60 * 1_000,
    queryFn: async (): Promise<RegistryState> => {
      const sdk = getBenchRegistryClient()
      return sdk.getRegistryState()
    },
  });
};

export const clearBenchRegistryCache = () => {
  const queryKey = [queryKeyPrefix];
  queryClient.invalidateQueries({ queryKey });
};
    